import type { BoardInfo } from '../sync/api';

/** The user's own order first, then any board it does not name yet, in the server's order. */
export function orderBoards(boards: BoardInfo[], order: string[]): BoardInfo[] {
  const rank = new Map(order.map((id, i) => [id, i]));
  const at = (b: BoardInfo) => rank.get(b.id) ?? order.length + boards.indexOf(b);
  return [...boards].sort((a, b) => at(a) - at(b));
}
